import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { ExportLimitsMap, FormatsArray } from '../../Constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function createValueExtractor(onChangeCallback) {
  return event => {
    onChangeCallback(event.target.value);
  };
}
const FormatField = ({
  onChange,
  value,
  formats = FormatsArray,
  formatLimits = ExportLimitsMap
}) => {
  const {
    limit: selectedFormatLimit,
    text: selectedFormatLimitText
  } = formatLimits[value] || {};

  // select the formats that have a higher limit (or no limit) than the selected format
  const alternateFormats = selectedFormatLimit ? formats.filter(format => {
    var _formatLimits$format$, _formatLimits$format;
    return ((_formatLimits$format$ = (_formatLimits$format = formatLimits[format]) === null || _formatLimits$format === void 0 ? void 0 : _formatLimits$format.limit) !== null && _formatLimits$format$ !== void 0 ? _formatLimits$format$ : Infinity) > selectedFormatLimit;
  }).map(format => format.toUpperCase()) : [];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.formatLabel"
      }),
      children: /*#__PURE__*/_jsx(Select, {
        value: value,
        onChange: createValueExtractor(onChange),
        options: formats.map(format => ({
          text: format.toUpperCase(),
          value: format
        }))
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "300",
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsxs(Text, {
        as: "small",
        children: [selectedFormatLimitText, !selectedFormatLimitText && selectedFormatLimit && alternateFormats.length === 0 && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "exportDialog.fields.limitCustom",
          options: {
            format: value.toUpperCase(),
            limit: I18n.formatNumber(selectedFormatLimit)
          }
        }), !selectedFormatLimitText && selectedFormatLimit && alternateFormats.length > 0 && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "exportDialog.fields.limitCustomWithAlternatives",
          options: {
            format: value.toUpperCase(),
            limit: I18n.formatNumber(selectedFormatLimit),
            alternateFormats: I18n.formatList(alternateFormats, {
              exclusive: true
            })
          }
        })]
      })
    })]
  });
};
export default FormatField;